const ALLOWED_SEARCH_PARAMS = ['q'];
const TRACK_FEAT_NAME = 'module';

export {TRACK_FEAT_NAME, ALLOWED_SEARCH_PARAMS};
